/* eslint-disable @next/next/no-img-element */
import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import React from "react";
import Layout from './_layout/index'
import { NextPageLayout } from 'src/utils/types/getLayout'

const originParam = "";

export const getStaticProps = (async() => {
	const { setupServices } = (await import('../services.setup.client'));

	const { urlBase } = setupServices();

	const accessLink = (urlBase: string) => [
		{
			name: "Departamentos en venta",
			value: `${urlBase}/venta/departamento`,
		},
		{
			name: "Casas en venta",
			value: `${urlBase}/venta/casa`,
		},
		{
			name: "Departamentos en arriendo",
			value: `${urlBase}/arriendo/departamento`,
		},
		{
			name: "Casas en arriendo",
			value: `${urlBase}/arriendo/casa`,
		},
	];

	return {
		props: {
			urlBase,
			accessLink: accessLink(urlBase)
		},
	}
}) satisfies GetStaticProps<{
	urlBase: string,
	accessLink: {
		name: string;
		value: string;
	}[]
}>

const Custom404: NextPageLayout<InferGetStaticPropsType<typeof getStaticProps>> = (props) => {
	return (
		<div className="main main-404">
			<div className="cont404">
				<div className="row">
					<div className="col-sm-4">
						<img
							src="https://d2jd36q67phkec.cloudfront.net/toctoc/img/404.png"
							alt="logo"
						/>
					</div>
					<div className="col-sm-8">
						<h1 className="tt">
							<strong className="color-main">¡UPS!</strong>
						</h1>
						<h3 className="subtitle">Te vemos un poco perdido. </h3>
						<h3 className="subtt description cont404-text-light">
							Al parecer este contenido no está disponible o ya no existe.
						</h3>
						<p>
							Te sugerimos ir a la
							<a href={`${props.urlBase}?${originParam}`}>
								<strong>página de inicio</strong>
							</a>
							e intentar con nuestro
							<a href={`${props.urlBase}?${originParam}`}>
								<strong>buscador</strong>
							</a>
							o también probar con estas sugerencias:
						</p>
						<ul className="text-left pl-3">
							{props.accessLink.map((item) => (
								<li key={item.value}>
									<a href={item.value}>{item.name}</a>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

Custom404.getLayout = function getLayout(page, layoutData) {
	return <Layout {...layoutData}>{page}</Layout>;
};

export default Custom404;
